<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Disk Information</h4>
    
  <el-table :data="tableData" stripe style="width: 100%" border class="fhv-table">
    <el-table-column prop="Partition" label="Partition" width="180"></el-table-column>
    <el-table-column prop="Total" label="Total" width="180"></el-table-column>
    <el-table-column prop="Available" label="Available"></el-table-column>
    <el-table-column prop="Used" label="Used"></el-table-column>
    <el-table-column prop="Use" label="Use%"></el-table-column>
    <el-table-column prop="System_Type" label="System_Type"></el-table-column>
  </el-table>

    </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      tableData: [
]
    };
  },
  methods: {
    getData() {
      this.loading = true;
      axios.post("/boafrm/getDiskStatus").then(res => {
        this.loading = false;
        let data=res.data;
        this.tableData=[];
        if(typeof data != "object") return;
        for(var i=0;i<data.arr.length-1;i++){
            this.tableData.push({
                Partition:data.arr[i].Partition,
                Total:data.arr[i].Total,
                Available:data.arr[i].Available,
                Used:data.arr[i].Used,
                Use:data.arr[i].Use,
                System_Type:data.arr[i].System_Type,
            });
        }
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>





